
//@ts-nocheck
import React, { useEffect, useState, useCallback, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Badge from '../../../components/common/Badge'
import { RootState } from '../../../app/store'
import { ApiResponse, MemberData } from '../../base/baseTypes'
import { baseMemberDetailsData, baseMemberDetailsDataStatus1, baseMemberInviteData, deleteBaseMemberStatusData, updateBaseMemberRoleChnage } from '../../base/baseSlice'
import { useAppDispatch } from '../../../app/hooks'
import { Toaster, toast } from 'sonner';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../../components/common/LoadingSpinner'
import { ThreeDotIcon } from '../../../components/icons'
import { ChevronDownIcon, CrossIcon, ExclamationIcon } from '../../../components/icons/Icons'

const roleList = [{ name: "admin" }, { name: "manager" }, { name: "member" }]
const roleSearchList = [{ name: "all" }, { name: "admin" }, { name: "manager" }, { name: "member" },
//  { name: "pending" }, { name: "deleted" },
{ name: "suspended" }]

interface MemberProps {
  userDetails: UserDetails | null;
}
type DropDownProps = {
  selectValue?: string,
  disable?: string
  data: {
    name: string
  }[],
  previousValue?: string,
  onChangeValue?: (val: string) => void,
  onDelete?: () => void,
  onArchived?: () => void;
  onActive?: () => void;
  onSuspend?: () => void;
  onPending?: () => void;
  channel?: boolean;
  style?: React.CSSProperties;
  disabled?: boolean,  // Added new disabled prop


}
function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}


function DropDown({ data, disable, onChangeValue, previousValue, onDelete, onSuspend, onArchived, onActive, onPending, channel, style, disabled }: DropDownProps) {
  const [value, setValue] = useState(previousValue)
  const isDisabled = disabled || disable === "admin"


  useEffect(() => {
    setValue(previousValue);
  }, [previousValue]);

  // Common button styles
  const buttonStyles = `
        flex w-full items-center justify-between gap-x-1.5 rounded-md bg-white
        mt-[-1px]  py-1.5 px-[10px]  text-sm text-[14px] sm:leading-4 border border-solid border-[#e7e7e8] font-medium cursor-pointer
        ${isDisabled
      ? 'bg-slate-200 cursor-not-allowed opacity-50'
      : 'bg-white hover:border-[#a9a9bc] hover:ring-surface-300 hover:bg-white'
    }
        border-solid border-[1px] border-[#d1d1db]
        focus:outline focus:outline-2 focus:-outline-offset-2
        focus:outline-indigo-600
    `

  // Render static button when disabled
  if (isDisabled) {
    return (
      <div className={`${channel ? '' : 'relative text-left'}`}>
        <button
          type="button"
          disabled
          className={buttonStyles}
        >
          <p className='text-sm fontfamily font-[400] capitalize'>
            {value}
          </p>

          <ChevronDownIcon />
        </button>
      </div>
    )
  }

  const handleItemClick = (itemName: string) => {

    // setValue(itemName);
    if (onChangeValue) {
      onChangeValue(itemName);
    }
    if (itemName === "deleted" && onDelete) {
      onDelete();
    } else if (itemName === "suspended" && onSuspend) {
      onSuspend();
    } else if (itemName === "deleted" && onDelete) {
      onDelete();
    } else if (itemName === "archived" && onArchived) {
      onArchived()
    } else if (itemName === "active" && onActive) {
      onActive()
    }
    else if (itemName === "pending" && onPending) {
      onPending()
    }
  };

  return (
    <Menu as="div" className={`${channel ? '' : 'relative text-left'}`}>
      {disable === "admin" ?
        <button type="button" disabled className="capitalize w-20 flex items-center justify-between cursor-not-allowed rounded bg-slate-200 px-2 py-1 text-xs font-semibold text-white shadow-sm
             hover:bg-slate-200
             focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          <p className="block text-[12px] md:text-sm lg:text-sm font-medium leading-6 text-gray-900">{value}</p>
          <ChevronDownIcon />
        </button>

        :
        <div>
          <Menu.Button className={buttonStyles}>
            <p className='text-sm fontfamily font-[400] capitalize'>
              {value}
            </p>
            <ChevronDownIcon />
          </Menu.Button>
        </div>
      }
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items style={style} className="absolute  z-10 mt-[9px] left-[0px] bg-white w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
          <div className="py-1">
            {data && (<>
              {data.map((item: { name: string }, index) => {
                return (
                  <Menu.Item key={index}>
                    {({ active }) => (
                      <button
                        // onClick={() => {
                        //     setValue(item.name);
                        //     onChangeValue?.(item.name);
                        //     if (item.name === "suspended" && onDelete) {
                        //         onDelete(); 
                        //     }
                        // }}
                        onClick={() => handleItemClick(item.name)}
                        className={classNames(
                          active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                          'relative flex cursor-default capitalize select-none w-full items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                        )}
                      >
                        {/* {item.name === "suspended" ? "Delete" : item.name} */}
                        {item.name}
                      </button>
                    )}
                  </Menu.Item>
                )
              })}

            </>)}

          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

const BaseMember: React.FC<MemberProps> = React.memo(({ userDetails }) => {
  const [selectRole, setSelectRole] = useState<any>("admin")
  const [selectSearchRole, setSelectSearchRole] = useState("all")

  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState("")
  const [data, setData] = useState<any>()
  const [memberData, setMemberData] = useState<MemberData[]>([]);

  const dispatch = useAppDispatch();
  const { error } = useSelector((state: RootState) => state.base);
  const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [addBaseLoading, setAddBaseLoading] = useState(false)
  const [addToBase, setAddToBase] = useState(false)
  const [filteredMemberData, setFilteredMemberData] = useState<MemberData[]>([])
  const [searchEmail, setSearchEmail] = useState("")
  const [userRole, setUserRole] = useState<string | null>(null);
  const baseUserInfoString1 = localStorage.getItem('userDetails')
  const UserBaseId = baseUserInfoString1 ? JSON.parse(baseUserInfoString1) : null;
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [searchName, setSearchName] = useState("");


  // useEffect(() => {
  //   const baseInfo = localStorage.getItem('baseMembersDetails');
  //   if (baseInfo) {
  //     const memberDataArray: ApiResponse = JSON.parse(baseInfo);
  //     setMemberData(memberDataArray.data.baseMembers);
  //     setFilteredMemberData(memberDataArray.data.baseMembers)
  //     // localStorage.setItem('baseMembersDetails', JSON.stringify(memberDataArray));
  //   }
  // }, []);





  useEffect(() => {
    if (baseId) {
      
      const fetchData = async () => {
        const storedBaseMember = localStorage.getItem('baseMembersDetails');
        // if (storedBaseMember) {
        //   setMemberData(JSON.parse(storedBaseMember));
        //   setFilteredMemberData(JSON.parse(storedBaseMember).data.baseMembers)
        // } else {
          try {
            const baseResponse = await dispatch(baseMemberDetailsData(userDetails?.id || baseId));
            setMemberData(baseResponse.payload.data.baseMembers);
            setFilteredMemberData(baseResponse.payload.data.baseMembers)
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        // }
      };
      fetchData();
    }
  }, [baseId, dispatch]);



  useEffect(() => {
    filterMembers()
  }, [searchEmail, searchName, selectSearchRole, memberData])


  useEffect(() => {
    const storedMemberData = localStorage.getItem('baseMembersDetails');


    if (storedMemberData) {
      const parsedData = JSON.parse(storedMemberData); // Parse the storedMemberData
      setMemberData(parsedData.data.baseMembers); // Access the data.baseMembers property
    }
  }, []);


  useEffect(() => {
    return () => {
      //   dispatch(clearBaseInfo());
    };
  }, [dispatch]);

  useEffect(() => {
    const baseInfo = localStorage.getItem('baseMembersDetails');
    const baseUserInfoString = localStorage.getItem('userDetails');

    if (baseInfo && baseUserInfoString) {
      const memberDataArray = JSON.parse(baseInfo);
      const baseUserInfo = JSON.parse(baseUserInfoString);

      setMemberData(memberDataArray.data.baseMembers);
      const matchingMember = memberDataArray.data.baseMembers.find(
        (member: MemberData) => member.id === baseUserInfo.id
      );

      if (matchingMember) {
        setUserRole(matchingMember.role);
      }
    }
  }, []);


  // delete 
  const handleDeleteBoard = useCallback(async (id: number, status: string) => {
    try {
      const res = await dispatch(deleteBaseMemberStatusData({ baseId, memberId: id, status }));

      if (res?.payload?.status === 200) {
        toast.success("Role has beeen deleted")
        const baseResponse = await dispatch(baseMemberDetailsData(baseId));
        setMemberData(baseResponse.payload.data.baseMembers);
      }
    } catch (error) {
      toast.error('Error deleting item!');
    }
  }, [dispatch, baseId]);

  // suspened board
  const handleSuspendedBoard = useCallback(async (id: number, status: string) => {
    try {
      const res = await dispatch(deleteBaseMemberStatusData({ baseId, memberId: id, status }));

      if (res?.payload?.status === 200) {
        toast.success("Role has beeen updated")
        const baseResponse = await dispatch(baseMemberDetailsData(baseId));
        setMemberData(baseResponse.payload.data.baseMembers);
      }
    } catch (error) {
      toast.error('Error deleting item!');
    }
  }, [dispatch, baseId]);


  // active 
  const handleActiveBoard = useCallback(async (id: number, status: string) => {
    try {
      const res = await dispatch(deleteBaseMemberStatusData({ baseId, memberId: id, status }));

      if (res?.payload?.status === 200) {
        toast.success("Role has beeen updated")
        const baseResponse = await dispatch(baseMemberDetailsData(baseId));
        setMemberData(baseResponse.payload.data.baseMembers);
      }
    } catch (error) {
      toast.error('Error deleting item!');
    }
  }, [dispatch, baseId]);


  const handleDelete = async () => {
    setLoading1(true)
    try {
      const res = await dispatch(baseMemberDetailsDataStatus1({ userId: baseId, status: 'deleted' }));
      if (res.payload) {
        setFilteredMemberData(res.payload.data.baseMembers)
        // Update local storage
        // localStorage.setItem('baseMembersDetails', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setLoading1(false)
    }
  };

  const handleSuspend = async () => {
    setLoading(true)
    try {
      const res = await dispatch(baseMemberDetailsDataStatus1({ userId: baseId, status: 'suspended' }));
      if (res.payload) {
        setFilteredMemberData(res.payload.data.baseMembers)
        // Update local storage
        // localStorage.setItem('baseMembersDetails', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Suspend failed:', error);
    } finally {
      setLoading(false)
    }
  };

  const handlePending = async () => {
    setLoading2(true)
    try {
      const res = await dispatch(baseMemberDetailsDataStatus1({ userId: baseId, status: 'pending' }));
      if (res.payload) {
        setFilteredMemberData(res.payload.data.baseMembers)
        // Update local storage
        // localStorage.setItem('baseMembersDetails', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Delete failed:', error);
    } finally {
      setLoading2(false)
    }
  };


  if (error) {
    return <div>Error: {error}</div>;
  }


  const add_baseHandler = () => {
    setAddBaseLoading(true)
    const userId = baseId
    if (email.length === 0) {
      setEmailError("Enter your email address");
      setAddBaseLoading(false)
    } else {
      dispatch(baseMemberInviteData({
        payload: { email, role: selectRole }, // Changed 'selectRole' to 'role'
        userId
      })).unwrap()
        .then((res) => {
          setData(res);
          toast.success(res?.message);
          setAddToBase(false)
        })
        .catch((err) => {
          setAddBaseLoading(false)
        })
        .finally(() => {
          setAddBaseLoading(false); // End loading
        });
    }
  };

  const handleAddMember = () => {
    setAddToBase(true)
  }



  // local search 

  const handleSearchNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchName(e.target.value);
  };

  const filterMembers = () => {
    let filtered = [...memberData]; // Create a copy to avoid mutating the original


    if (searchEmail) {
      filtered = filtered.filter(member =>
        member.email.toLowerCase().includes(searchEmail.toLowerCase())
      )
    }

    if (searchName) {
      filtered = filtered.filter(member =>
        member.name.toLowerCase().includes(searchName.toLowerCase())
      );
    }
    // Filter by role or status
    if (selectSearchRole !== "all") {
      if (selectSearchRole === "pending") {
        // Filter by pending status
        filtered = filtered.filter(member => member.status === "pending");
      } else if (selectSearchRole === "suspended") {
        // Filter by suspended status
        filtered = filtered.filter(member => member.status === "suspended");
      } else {
        // Filter by role (admin, manager, member)
        filtered = filtered.filter(member =>

          member.role.toLowerCase() == selectSearchRole.toLowerCase()
        );
      }
    }

    // if (selectSearchRole !== "all") {
    //   filtered = filtered.filter(member =>
    //     member.role.toLowerCase() === selectSearchRole.toLowerCase() ||
    //     (selectSearchRole === "pending" && member.status === "pending")
    //   )
    // }

    setFilteredMemberData(filtered)
  }
  // Add in filterMembers function

  // Add after filtering in handleSearchRoleChange
  const handleSearchEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchEmail(e.target.value)
  }

  const handleSearchRoleChange = (role: string) => {
    setSelectSearchRole(role);

    // Ensure filter is applied with correct role
    let filtered = [...memberData];

    if (searchEmail) {
      filtered = filtered.filter(member =>
        member.email.toLowerCase().includes(searchEmail.toLowerCase())
      );
    }

    if (searchName) {
      filtered = filtered.filter(member =>
        member.name.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    // Filter by role or status
    if (role !== "all") {
      if (role === "pending") {
        filtered = filtered.filter(member => member.status === "pending");
      } else if (role === "suspended") {
        filtered = filtered.filter(member => member.status === "suspended");
      } else {
        // Filter by role and ensure the role is preserved exactly
        filtered = filtered.filter(member =>
          member.role.toLowerCase() === role.toLowerCase()
        ).map(member => ({
          ...member,
          // Force the role to match the filter exactly
          role: role.toLowerCase()
        }));
      }
    }

    // Set the filtered data
    setFilteredMemberData(filtered);
  };


  const handleRoleChange = async (userId: number, newRole: string) => {
    const isChangingSelfRole = userDetails?.id === userId;

    if (isChangingSelfRole && userRole === 'admin') {
      // toast.error("Administrators cannot change their own role");
      return;
    }

    if (baseId && userId && newRole) {

      try {

        const response = await dispatch(updateBaseMemberRoleChnage({
          baseId,
          userId,
          roleId: newRole
        }));

        if (response.meta.requestStatus === 'fulfilled') {
          toast.success("Role updated successfully");
          setMemberData(prevData =>
            prevData.map(member =>
              member.id === userId ? { ...member, role: newRole } : member
            )
          );

          // Update filtered data if it exists
          setFilteredMemberData(prevData =>
            prevData.map(member =>
              member.id === userId ? { ...member, role: newRole } : member
            )
          );

          // Update local storage
          const baseMemberDetailsString = localStorage.getItem('baseMembersDetails');
          if (baseMemberDetailsString) {
            const baseMemberDetails = JSON.parse(baseMemberDetailsString);
            baseMemberDetails.data.baseMembers = baseMemberDetails.data.baseMembers.map(
              (member: any) => member.id === userId
                ? { ...member, role: newRole }
                : member
            );
            localStorage.setItem('baseMembersDetails', JSON.stringify(baseMemberDetails));
          }
          if (isChangingSelfRole) {
            setUserRole(newRole);
          }
          filterMembers();
        } else {
          toast.error("Failed to update role");
        }
      } catch (error) {
        console.error("Error updating member role:", error);
        toast.error("Error updating role");
      }
    }
  };

  // Modified DropDown rendering in the member list
  const renderRoleDropdown = (member) => {
    const isCurrentUserAdmin = userRole === 'admin';
    const isChangingSelf = UserBaseId?.id === member.id;
    const isDisabled = isCurrentUserAdmin && isChangingSelf;

    // Important: Debug the member data to understand what we're receiving

    // Directly use the role that should be displayed based on the filter
    let displayRole = member.role.toLowerCase();

    // If we're filtering by role, make sure the display matches the filter
    if (selectSearchRole !== 'all' &&
      selectSearchRole !== 'pending' &&
      selectSearchRole !== 'suspended') {
      // If we're filtering by a specific role, ensure we show that role in the dropdown
      displayRole = selectSearchRole.toLowerCase();
    }

    return (
      <div className={`sm:col-span-3 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
        <DropDown
          onChangeValue={(newRole) => handleRoleChange(member.id, newRole)}
          data={roleList.map(role => ({ name: role.name }))}
          previousValue={displayRole}  // Use the determined display role
          disabled={isDisabled}
        />
      </div>
    );
  };



  return (
    <main className='h-full flex'>
      <div className=' w-full flex justify-center'>
        <div className='w-full'>
          <div className='flex flex-col gap-y-1 w-full'>
            <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
              Base Members
            </h2>
            <p className='text-sm leading-5 text-[#5c5c5e] font-medium'>
              Invite, manage, and define roles for members of your organization.
            </p>
          </div>
          <div className='bg-[#e0e0e0] w-full h-[1px] my-8'></div>
          <div className=' mt-6 lg:my-8 flex items-center  w-full gap-x-3'>

            <div className='w-full lg:w-[40%]'>
              {/* <label htmlFor='searchEmail' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
                Base Members
              </label> */}
              <div className='mt-[0px]'>
                <input
                  id='searchEmail'
                  name='searchEmail'
                  type='text'
                  placeholder='Search by name'
                  value={searchName}
                  onChange={handleSearchNameChange}
                  className="flex w-full grow border px-4 pt-2 pb-[10px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                    focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                    border-[#e7e7e8] dark:border-surface-100 focus:outline-indigo-600 h-[34px] rounded-[0.375rem]"
                />
              </div>
            </div>

            <div className='w-full lg:w-[20%]'>
              <div className='mt-[0px]'>
                <DropDown
                  onChangeValue={handleSearchRoleChange}
                  data={roleSearchList}
                  previousValue={selectSearchRole}
                  onDelete={handleDelete}
                  onSuspend={handleSuspend}
                  onPending={handlePending}
                />
                {/* <DropDown onChangeValue={(value) => setSelectSearchRole(value)} data={roleSearchList} previousValue={selectSearchRole} /> */}

              </div>
            </div>
            <div className='w-full lg:w-[40%]'>
              <div className='mt-[0px] flex justify-end'>
                <button
                  onClick={handleAddMember}
                  className='flex w-fit justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white
             shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                >
                  Add Base Member
                </button>
              </div>

            </div>
          </div>


          {/* {filteredMemberData.length > 0 && ( */}
          <div className='bg-white rounded-lg border border-solid border-[#0009321f]'>
            <div className='flex items-center w-full'>
              <div className='font-semibold text-[#1c2024] text-sm w-[71.5%] px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]'>
                Name
              </div>
              <div className='font-semibold text-[#1c2024] w-[28.5%] text-sm  px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]'>
                Role
              </div>
            </div>
            {loading || loading1 ? (
              <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 291px)' }}>
                <div className="simple-spinner-loader">
                  <span></span>
                </div>
              </div>
            ) : filteredMemberData.length === 0 ? (
              <div className='w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3'>
                <ExclamationIcon />
                <p className='text-[#0000007a] text-[13px]'>No results found</p>
              </div>
            ) : (
              <ul
                role="list"
                className="list-none w-full"
              >
                {filteredMemberData.map((items: any, index) => {
                  const data = items?.name?.charAt(0).toUpperCase();
                  return (
                    <li
                      key={index}
                      className="flex flex-row items-center justify-between text-[0.875rem] px-[11.4px] py-[11.4px] w-full  border-b border-[#0009321f] last-of-type:border-none"
                    >
                      <div className="flex min-w-0 gap-x-4 items-center">
                        {items.profile_pic ? (
                          <img
                            src={`${process.env.REACT_APP_API_BASE_URL}/${items.profile_pic}`}
                            alt="Selected file preview"
                            className="h-[30px] w-[30px] flex-none rounded-full text-gray-300"
                          />
                        ) : (
                          <div className="flex shrink-0">
                            <span
                              className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border-none text-[13px] font-semibold text-white capitalize"
                              style={{ backgroundColor: "rgb(107, 114, 128)" }}
                            >
                              {data}
                            </span>
                          </div>
                        )}
                        <div className="min-w-0 flex-auto">
                          <p className="">
                            <span className='text-[0.8125rem] font-semibold leading-5 text-[#1b1b1b]'>
                              {items.name}
                            </span>
                            {
                              items.status === 'suspended' &&
                              <Badge status={items?.status} />
                            }

                          </p>
                          <p className=" flex text-xs text-[12px] leading-4 text-[#5c5c5e]">{items?.email}</p>
                        </div>
                      </div>
                      <div className="flex items-center justify-end">

                        {renderRoleDropdown(items)}


                        {userRole === "admin" && (
                          <div className="px-2 flex items-center">
                            {!(UserBaseId?.id === items.id) && (
                              <Menu as="div" className="relative inline-block text-left">
                                <div>
                                  <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
                                    <span className="sr-only">Open options</span>
                                    <ThreeDotIcon />
                                  </MenuButton>
                                </div>
                                <Transition
                                  enter="transition ease-out duration-100"
                                  enterFrom="transform opacity-0 scale-95"
                                  enterTo="transform opacity-100 scale-100"
                                  leave="transition ease-in duration-75"
                                  leaveFrom="transform opacity-100 scale-100"
                                  leaveTo="transform opacity-0 scale-95"
                                >
                                  <MenuItems className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[108px] min-w-[108px] w-full overflow-hidden rounded-lg border border-border
                                 bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                                 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                                  data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                    <div className="py-1">
                                      <MenuItem>
                                        {({ focus }) => (
                                          <Link
                                            to="#"
                                            className={classNames(
                                              focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                              "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                            )}
                                            onClick={() => handleDeleteBoard(items.id, "deleted")}
                                          >
                                            Delete
                                          </Link>
                                        )}
                                      </MenuItem>

                                      {
                                        items.status !== 'suspended' &&
                                        <MenuItem>
                                          {({ focus }) => (
                                            <Link
                                              to="#"
                                              className={classNames(
                                                focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                              )}
                                              onClick={() => handleSuspendedBoard(items.id, "suspended")}
                                            >
                                              Suspended
                                            </Link>
                                          )}
                                        </MenuItem>
                                      }

                                      {
                                        items.status === 'suspended' &&
                                        <MenuItem>
                                          {({ focus }) => (
                                            <Link
                                              to="#"
                                              className={classNames(
                                                focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                              )}
                                              onClick={() => handleActiveBoard(items.id, "active")}
                                            >
                                              Active
                                            </Link>
                                          )}
                                        </MenuItem>
                                      }

                                    </div>
                                  </MenuItems>
                                </Transition>
                              </Menu>
                            )}
                          </div>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          {/* )} */}

        </div>


      </div>
      {/* <AlertPopup data={data} show={showAlert} setShow={() => setShowAlert(false)} /> */}
      {/* <SliderOvers setData={(e: any) => setData(e)} memberData={memberData} memberId={memberId} baseId={baseId} show={showSlider} setShow={() => setShowSlider(false)} setShowAlert={() => setShowAlert(true)} /> */}




      <Dialog open={addToBase} onClose={setAddToBase} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setAddToBase(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Add Member
                </DialogTitle>

                <div className='w-full mt-5'>
                  <label htmlFor='email' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>
                    Email
                  </label>
                  <div className='mt-[6px]'>
                    <input
                      id='email'
                      name='email'
                      type='email'
                      value={email}
                      onChange={(e) => {
                        setEmailError("");
                        setEmail(e.target.value)
                      }}
                      autoComplete='email'
                      placeholder='Email address'
                      className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                    focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                    border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                    />
                    <p className="mt-[6px] text-sm text-red-600" id="email-error">
                      {emailError}
                    </p>

                  </div>
                </div>
                <div className='w-full mt-4'>
                  <label htmlFor='country' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>
                    Role
                  </label>
                  <div className='mt-[6px]'>
                    <DropDown onChangeValue={(e: any) => setSelectRole(e)} data={roleList} previousValue={selectRole} />
                  </div>
                </div>

              </div>
              <div className="flex gap-x-4 items-center justify-end mt-5">
                <button
                  onClick={add_baseHandler}
                  type="submit"
                  className="flex w-fit justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"

                >
                  {addBaseLoading ? (
                    <div className='flex items-center  gap-[6px]'>
                      Add to Base
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    'Add to Base'
                  )}
                </button>

              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>






    </main>

  )
});
export default BaseMember
